import React from 'react'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import CircularProgress from '@mui/material/CircularProgress'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward'
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward'

const eurFormatter = new Intl.NumberFormat('fi-FI', { style: 'currency', currency: 'EUR' })
const pctFormatter = new Intl.NumberFormat('fi-FI', { style: 'percent', maximumFractionDigits: 1 })
const numFormatter = new Intl.NumberFormat('fi-FI', { maximumFractionDigits: 1 })

const formatValue = (value, unit) => {
  if (value === null || value === undefined || isNaN(value)) return '—'
  if (unit === '€') return eurFormatter.format(value)
  if (unit === '%') return numFormatter.format(value) + ' %'
  return numFormatter.format(value)
}

const formatDelta = (current, previous, unit) => {
  if (current === null || previous === null || current === undefined || previous === undefined) return null
  const abs = current - previous
  const pct = previous === 0 ? null : abs / previous
  const sign = abs > 0 ? '+' : abs < 0 ? '−' : ''
  const absStr = unit === '€'
    ? eurFormatter.format(Math.abs(abs))
    : unit === '%'
      ? numFormatter.format(Math.abs(abs)) + ' %-yks.'
      : numFormatter.format(Math.abs(abs))
  const pctStr = pct === null ? null : pctFormatter.format(Math.abs(pct))
  return { abs, pct, sign, absStr, pctStr }
}

const KpiCard = ({ title, value, previous, unit = '€', loading, comparisonLabel = 'vs viime viikko' }) => {
  const delta = formatDelta(value, previous, unit)
  const direction = delta ? (delta.abs > 0 ? 'up' : delta.abs < 0 ? 'down' : 'flat') : 'flat'
  const color = direction === 'up' ? '#28a745' : direction === 'down' ? '#dc3545' : '#6c757d'

  return (
    <Card sx={{ borderRadius: 2, height: '100%' }}>
      <CardContent sx={{ p: '12px 14px', '&:last-child': { pb: '12px' } }}>
        <Typography variant='caption' sx={{ color: 'text.secondary', textTransform: 'uppercase', letterSpacing: 0.3 }}>
          {title}
        </Typography>
        <Box sx={{ fontSize: 26, fontWeight: 600, lineHeight: 1.2, mt: 0.5 }}>
          {loading ? <CircularProgress size={18} /> : formatValue(value, unit)}
        </Box>
        {!loading && delta && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 0.5, fontSize: 12, color }}>
            {direction === 'up' && <ArrowUpwardIcon sx={{ fontSize: 14 }} />}
            {direction === 'down' && <ArrowDownwardIcon sx={{ fontSize: 14 }} />}
            <Box component='span'>
              {delta.pctStr ? `${delta.sign}${delta.pctStr}` : '—'}
              {' '}
              ({delta.sign}{delta.absStr})
            </Box>
            <Box component='span' sx={{ color: 'text.secondary', ml: 0.5 }}>{comparisonLabel}</Box>
          </Box>
        )}
      </CardContent>
    </Card>
  )
}

export default KpiCard
